import { type ReactNode, useRef } from 'react';
import { clsx } from 'clsx';
import { HorizontalStack } from '@interxfi/design-system/components/alignment/horizontal-stack';
import { VerticalStack } from '@interxfi/design-system/components/alignment/vertical-stack';
import { Button } from '@interxfi/design-system/components/button/button';
import MenuIcon from '@interxfi/design-system/icons/react/icon-menu';
import MenuCloseIcon from '@interxfi/design-system/icons/react/icon-menu-close';
import { usePreferredTimeZone } from '@interxfi/design-system/time-zone-context';
// import { GlobalSearch } from '../../global-search/global-search';
import { useLayoutContext } from '../context';
import { Breadcrumbs } from './breadcrumbs/breadcrumbs';
import { HoursIndicator } from './hours-indicator/hours-indicator';
import { UserMenu } from './user-menu/user-menu';
import styles from './topbar.module.scss';

interface TopbarProps {
  bare?: boolean;
  mobileSidebar?: ReactNode;
}

export function Topbar({ bare, mobileSidebar }: TopbarProps) {
  const timeZone = usePreferredTimeZone();
  const { handleCloseMobileNav, setIsMobileNavExpanded, isMobile, isMobileNavExpanded } = useLayoutContext();

  const actionBarRef = useRef<HTMLDivElement>(null);
  const actionBar = (
    <HorizontalStack
      align={isMobile ? 'space-between' : 'end'}
      blockAlign="center"
      className={styles.actionBar}
      gap={2}
      ref={actionBarRef}
      wrap="nowrap"
    >
      {/*<GlobalSearch />*/}
      {bare ? null : <HoursIndicator closeMobileNav={handleCloseMobileNav} isMobile={isMobile} timeZone={timeZone} />}
      <UserMenu closeMobileNav={handleCloseMobileNav} />
    </HorizontalStack>
  );

  return (
    <div className={clsx(styles.topbar, isMobile && styles.isMobile, isMobileNavExpanded && styles.isMobileNavExpanded, bare && styles.isBare)}>
      <VerticalStack className={styles.wrapperForNavActivator} gap={4}>
        <HorizontalStack align={bare ? 'end' : 'space-between'} blockAlign="center" className={styles.topbarContainer} gap={4} wrap="nowrap">
          {bare ? null : <Breadcrumbs />}

          {isMobile && !bare ? (
            <Button
              affixIcon={isMobileNavExpanded ? <MenuCloseIcon aria-hidden /> : <MenuIcon aria-hidden />}
              aria-label="Toggle navigation"
              className={styles.mobileNavActivator}
              onClick={() => setIsMobileNavExpanded(!isMobileNavExpanded)}
              size="small"
              variant="light"
            />
          ) : (
            actionBar
          )}
        </HorizontalStack>
        {isMobile && isMobileNavExpanded ? actionBar : null}
      </VerticalStack>

      {isMobile && isMobileNavExpanded ? <div className={styles.navContainer}>{mobileSidebar}</div> : null}
    </div>
  );
}
